import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {SearchDay} from '../../SearchDay';

import {useOptions} from './';

const defaultDatesOptions = {
    actionLocation: undef,
    alertTemplateComponent: undef,
    alertTemplateData: undef,
    allowErrorHighlighting: undef,
    autoProgress: undef,
    centered: undef,
    consolidateInputs: undef,
    dateFormatOptions: {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    },
    dayData: undef,
    dayTemplateComponent: SearchDay,
    disableTextInput: undef,
    displayYearFirst: undef,
    enableSameDayDateRange: undef,
    fadeOut: false,
    fadeOutDuration: 0,
    id: 'dates',
    inputIcon1Name: 'check-in',
    inputIcon2Name: 'check-out',
    inputName1: 'check-in',
    inputName2: 'check-out',
    maxDate: undef,
    minDate: undef,
    parentNode: undef,
    placement: undef,
    positionIconRight: undef,
    scrollNode: undef,
    showArrow: false,
    showInputIcon1: undef,
    showInputIcon2: undef,
    splitInputs: undef,
    wdioPrefix: undef
};

function useDatesOptions(props) {
    const {
        datesOptions: propsDatesOptions
    } = props;

    const {
        options: datesOptions
    } = useOptions(defaultDatesOptions, propsDatesOptions);

    const result = {
        datesOptions
    };

    useDebugValue(result);

    return result;
}

export {useDatesOptions};
